import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { isExternalUrl } from '../../../utils/links';
import { CmsMeta } from '../cmsMeta';

export type CmsButtonParams = {
	children: ReactNode;
	linkTo: string;
	className?: string;
};
export const CmsButton = ({ children, linkTo, className = '' }: CmsButtonParams): JSX.Element => {
	// the router would turn an absolute url into a path on this site, so it gets a plain anchor
	if (linkTo && isExternalUrl(linkTo)) {
		return (
			<a href={linkTo} className={`button ${className}`}>
				{children}
			</a>
		);
	}
	return (
		<Link to={linkTo} className={`button ${className}`}>
			{children}
		</Link>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A button that links somewhere. The text is the child; `linkTo` is a path on the site, or a full https url for another site such as a review page, and a button without one leads nowhere.',
	example: [
		'CmsButton',
		{
			linkTo: '/varumarken/leitz',
		},
		'Se hela Leitz-sortimentet',
	],
};
